import { render } from "./HorizontalAncestorChart.vue?vue&type=template&id=653156da&scoped=true"
import script from "./HorizontalAncestorChart.vue?vue&type=script&lang=js"
export * from "./HorizontalAncestorChart.vue?vue&type=script&lang=js"

import "./HorizontalAncestorChart.vue?vue&type=style&index=0&id=653156da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653156da"]])

export default __exports__